/* eslint-disable no-param-reassign */
export default (state) => {
  state.error = null;
  state.pending = true;
  state.broadcast = null;
};
